/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import TwoColumns from '../components/layouts/TwoColumns';
import {ColumnContainer, PersonSection} from '../components/layouts/TwoColumns';
import AmandaFox from '../assets/images/amandafox.png';
import Jens from '../assets/images/jens.png';
import Eirik from '../assets/images/eirik.png';
import Eskild from '../assets/images/eskild.png';
import GetCertified from '../assets/images/LandingPage/getCertified.png';
import Image from 'next/image';
export const meta = {
  author: 'Jens Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  mdx: true,
  primaryActionText: "Enroll now",
  primaryActionLinkOverride: "https://curipod.notion.site/AI-Certified-Curipod-Educator-5d26e6eabf964166ae94c5d638ee7d3b?pvs=4",
  hideActions: false,
  meta: meta,
  title: "Become an AI certified Curipod educator",
  subTitle: "Do you want to lead the change in education? Learn about generative AI and how it can help you and your students. Take our free 10 hour certification course to earn your badge, and master the AI in Curipod!",
  image: GetCertified,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      ul: "ul",
      li: "li",
      p: "p",
      a: "a"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "Who is it for?"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Teachers"
        }), "\n", _jsx(_components.li, {
          children: "Instructional technologists"
        }), "\n", _jsx(_components.li, {
          children: "Curriculum content creators"
        }), "\n", _jsx(_components.li, {
          children: "Professional development coaches"
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "What does the course cover?"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Part 1: Intro to Curipod"
        }), "\n", _jsx(_components.li, {
          children: "Part 2: What is generative AI and how does it change the world?"
        }), "\n", _jsx(_components.li, {
          children: "Part 3: Create lessons with Curipod AI"
        }), "\n", _jsx(_components.li, {
          children: "Part 4: Classroom engagement with the Curipod pedagogics"
        }), "\n", _jsx(_components.li, {
          children: "Part 5: Assessing AI tools in education"
        }), "\n", _jsx(_components.li, {
          children: "Part 6: AI Certification"
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "What does the course cost?"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "It's completely free of charge through the summer until september 1st."
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "What accreditation do you get?"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Certification that you are an AI Certified Curipod Educator."
        }), "\n", _jsx(_components.li, {
          children: "Badge you can use for your email, social media or similar."
        }), "\n"]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "How do i get started?"
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://curipod.notion.site/AI-Certified-Curipod-Educator-5d26e6eabf964166ae94c5d638ee7d3b?pvs=4",
          children: "Enroll now"
        })
      }), "\n", _jsx(_components.h2, {
        children: "Important info"
      }), "\n", _jsx(_components.p, {
        children: "If you're not able to log in with a google account from your school/district, try with a personal account."
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {})]
    });
  }
}
export default MDXContent;
